import { TFunction } from 'i18next';
import { z } from 'zod';

export const getTypeSchema = (t: TFunction) =>
  z.object({
    title: z.string().min(1, t('common.validation.titleRequired')),
    visibleOnApp: z.boolean().default(false),
  });
